var map = {
	"./image1.webp": 6443,
	"./image2.webp": 2576,
	"./image3.webp": 4195,
	"./image4.webp": 1994,
	"./image5.webp": 2875,
	"./image6.webp": 4199,
	"./image7.webp": 3976,
	"./image8.webp": 6192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8271;